export const jsonEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);
